import React, { useEffect } from "react";

import { useRouteMatch, useHistory } from "react-router-dom";
import ListDetailsSection from "../../ListDetailsSection";
import EventsList from "../../EventsList";
import EventMap from "../../EventMap";
import { offset, eventsLimit } from "../../../helpers/pagination";
import { useQueryParams } from "../../../hooks/useQueryParams";

import { useEvents } from "../../../hooks/useEvents";
import { useOrganizationContext } from "../../../contexts/OrganizationProvider";
import { useLiveStatusContext } from "../../../contexts/LiveStatusProvider";
import { ITabContent } from "../../TabbedContent";

// import DesktopFilters from "./DesktopFilters";
// import MobileFilters from "./MobileFilters";
// import AlertsFiltersProvider from "./AlertsFiltersProvider";
// import styles from "./index.module.scss";

const PigAlertsPage = ({ onActivated }: ITabContent) => {
  const match = useRouteMatch();
  const slugMatch = useRouteMatch<{ referenceId?: string }>(
    `${match.url}/:referenceId`
  );
  const history = useHistory();
  const { appStatus } = useLiveStatusContext();

  const { queryParams } = useQueryParams();
  const numericPage = parseInt(queryParams.page, 10);
  const page = Number.isInteger(numericPage) ? numericPage : 1;
  const paginationOffset = offset(page, eventsLimit);
  const { activeOrg } = useOrganizationContext();
  const pipelines = (activeOrg && activeOrg.pipelines) || [];
  const pipelineIds =
    pipelines && pipelines.map((pipeline: { id: string }) => pipeline.id);

  const selectedEventTypes = ["pig"];

  const { currentLiveEvents, reFetchQuery } = useEvents({
    queryName: "pigLiveEvents",
    filters: {
      pipelines: pipelineIds,
      sortBy: queryParams.sortBy,
      archived: false,
      types: selectedEventTypes,
      limit: eventsLimit,
      offset: paginationOffset
    }
  });

  useEffect(() => {
    if (appStatus.activePigEventCount) {
      reFetchQuery();
    }
  }, [appStatus.activePigEventCount, reFetchQuery]);

  const selectedEvent =
    slugMatch && slugMatch.params ? slugMatch.params.referenceId : undefined;

  const selectEvent = (referenceId: string) => {
    history.push(`${match.url}/${referenceId}${history.location.search}`);
  };

  console.log("PigAlertsPage rendered", currentLiveEvents);
  console.log("AppStatus", appStatus);

  if (onActivated) onActivated({ title: "active" });

  return (
    // <AlertsFiltersProvider>
    //   <div className={styles.ListMapWrapper}>
    <ListDetailsSection
      emptyStateText="No Alerts"
      totalEvents={currentLiveEvents.totalEvents}
      loading={currentLiveEvents.status === "loading" || !activeOrg}
      selectedEvent={selectedEvent}
      listComponent={
        <EventsList
          events={currentLiveEvents.events}
          selectedEvent={selectedEvent}
          setSelectedEvent={selectEvent}
        />
      }
      mapComponent={
        <EventMap
          canSearchOnMapMove={false}
          events={currentLiveEvents.events}
          scrollZoom
          ignoreEventForBoundary
        />
      }
      // headerComponent={
      //   <>
      //     <MobileFilters
      //       eventsCount={currentLiveEvents.events.length}
      //       totalEvents={currentLiveEvents.totalEvents}
      //     />
      //     <DesktopFilters
      //       eventsCount={currentLiveEvents.events.length}
      //       totalEvents={currentLiveEvents.totalEvents}
      //     />
      //   </>
      // }
    />
    //   </div>
    // </AlertsFiltersProvider>
  );
};

export default PigAlertsPage;
